import { ParallaxData } from '../../core/modules/Parallax/ParallaxController';
import ChunkBase from '../ChunkBase';
import { ChunkConditionsValues } from '../ChunkConditions';
import { RelicNameValues } from '../relics/relic';

export const WorldName = {
  Test: 'test',
  Shipwreck: 'shipwreck',
  Jungle: 'jungle',
  Cave: 'cave'
} as const;
export type WorldNameKeys = keyof typeof WorldName;
export type WorldNameValues = typeof WorldName[WorldNameKeys];

export const ChunkStage = {
  Start: 'start',
  Onboarding: 'onboarding',
  Mid: 'mid',
  End: 'end',
  Easy: 'easy',
  Medium: 'medium',
  Hard: 'hard'
};
export type ChunkStageKeys = keyof typeof ChunkStage;
export type ChunkStageValues = typeof ChunkStage[ChunkStageKeys];

export interface World {
  id: WorldNameValues;
  texture: string;
  parallaxLayers: ParallaxData[];
  playerSpawnPoint: { x: number; y: number };
  hasHardFloor: boolean;
  deathFloorY: number;
  chunkStartX: number;
  chunkStartY: number;
  relics: WorldRelic[];
  // startChunks: typeof ChunkBase[];
  // onboardingChunks: typeof ChunkBase[];
  // endChunks: typeof ChunkBase[];
  // chunks: ChunkGroup[];
  chunks: Partial<Record<ChunkStageValues, typeof ChunkBase[]>>;
  // startChunks: typeof ChunkBase[];
  // onboardingChunk: typeof ChunkBase[];
  // midChunks: typeof ChunkBase[];
  // endChunks: typeof ChunkBase[];
  stageOrdering: ChunkStageDetails[];
}

export interface ChunkStageDetails {
  name: ChunkStageValues;
  next?: ChunkStageValues;
  distance?: number;
  count?: number;
  rushMin?: number;
  rushMax?: number;
  conditions?: ChunkConditionsValues[];
}

// export interface ChunkGroup {
//   name: ChunkStageValues;
//   next?: ChunkStageValues;
//   distance: number;
//   chunks: typeof ChunkBase[];
// }

export interface WorldRelic {
  relic: RelicNameValues;
  distance: number;
  chunks: typeof ChunkBase[];
}
